import { Component, computed, inject, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ENVIRONMENT } from '../../../../../environments/environment.interface';
import { Relative } from '../../../../api/app-types/relative.app';

@Component({
	selector: 'lvr-client-relatives-item',
	imports: [TranslocoPipe],
	templateUrl: './client-relatives-item.html',
	styleUrl: './client-relatives-item.scss',
})
export class ClientRelativesItem {
	public readonly environment = inject(ENVIRONMENT);

	public readonly relative = input<Relative>();

	public readonly name = computed(() => {
		const rel = this.relative();
		if (!rel) {
			return '';
		}
		const name = rel.firstName
			? `${rel.lastName ?? ''}, ${rel.firstName ?? ''}`.trim()
			: `${rel.lastName ?? ''}`.trim();
		return name;
	});

	public hasBottomBorder = input<boolean>();
}
